var root = require('./_root');

/** Built-in value references. */
var Reflect = root.Reflect;

module.exports = Reflect;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_Reflect.js
 ** module id = 1287
 ** module chunks = 0
 **/